import { gql } from '@apollo/client'
import { BOUNDING_BOXES_FRAGMENT } from '../fragments'

export const ADD_IMAGE = gql`
  mutation AddImage($input: AddImageInput!) {
    addImage(input: $input) {
      image {
        url
        bucketFileName
        id
        created
        saved
        ... on DisplayAuditImage {
          boundingBoxSet {
            ...BoundingBoxes
          }
        }
      }
    }
  }
  ${BOUNDING_BOXES_FRAGMENT}
`
